import { PropsWithChildren } from 'react'

import { useCreation } from 'ahooks'

import { TableContextMenuStoreContext } from './contexts/StoreContext'
import { createTableContextMenuStore } from './store/createStore'

export const TableContextMenuProvider = ({ children }: PropsWithChildren) => {
  const store = useCreation(() => createTableContextMenuStore(), [])
  return (
    <TableContextMenuStoreContext value={store}>
      {children}
    </TableContextMenuStoreContext>
  )
}
